import { SearchFilter } from '../types';

export function useFilterItemByField(items: SearchFilter[], field: string) {
  return items?.filter((item) => item.field === field)?.at(0);
}
